import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { HeaderDisplayType, HeaderInteractionType } from '../../interfaces';
import Header from '../../views/app/Header';
import StickyHeader from '../../views/app/StickyHeader';
import './styles/ats-player.scss';

interface PlayerLayoutProps {
  title: string;
  children: React.ReactNode;
}

export function PlayerLayout({ title, children }: PlayerLayoutProps) {
  const shouldHideControls = useSelector((state) => state.app.shouldFadeOut);

  return (
    <div className="ats-player">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      {!shouldHideControls && (
        <Fragment>
          <StickyHeader overPlayer={true} />
          <Header
            title={title}
            hideTitle={false}
            displayType={HeaderDisplayType.Player}
            interactionType={HeaderInteractionType.CloseOnly}
          />
        </Fragment>
      )}

      {children}
    </div>
  );
}
